// extracted by mini-css-extract-plugin
export default {"base":"Container_base__Zp0hV","base--fluid":"Container_base--fluid__1lBB2"};